import "@adyen/adyen-web/dist/adyen.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./App.css";
import { Config, store } from "@cleeng/mediastore-sdk";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import Components from "./pages/Components/Components";

import RedeemMyGift from "./pages/RedeemMyGift/RedeemMyGift";
import Home2 from "./pages/Home2/Home2";
import AccountPage from "./pages/MyAccount/AccountPage";
import HomePageWithGift from './pages/Home2/HomeGift';

import { Popups } from "./components/Popups/Popups";
import $ from "jquery";
import cfg from "./Config";
import { Suspense, lazy } from 'react';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

import CookiePolicyComponent from "./pages/CookiePolicy/cookiepolicy";
import PromoCodeCheckout from './pages/Checkout/PromoCodeCheckout';
import NotFound from './pages/NotFound/NotFound';
import UpdateShippingAddress from './pages/Checkout/UpdateShippingAddress';

const Experience = lazy(() => import('./pages/Experience/Experience'));
const SubscribeExperience = lazy(() => import('./pages/SubscribeExperience/SubscribeExperience'));

const AccessPage = lazy(() => import('./pages/Access/Access'));
const UnlockAccessPage = lazy(() => import('./pages/Access/UnlockAccess'));

const CheckoutPage = lazy(() => import('./pages/Checkout/Checkout'));
const OrderConfirmed = lazy(() => import('./pages/Order/OrderConfirmed'));
const StartWatchingPage = lazy(() => import('./pages/Order/StartWatching'));
const RenewalCheckoutPage = lazy(() => import('./pages/Checkout/RenewalCheckout'));

const CustomCheckoutPage = lazy(() => import('./pages/Checkout/CustomCheckout'));
//const PromoCodeCheckout = lazy(() => import('./pages/Checkout/PromoCodeCheckout'));

//import _ from './fluent-svc'; // set the fluent click id...
//import Gift from "./pages/Gift/Gift";
const url_account = `https://${cfg.domain}/account`;
const url_components = `https://${cfg.domain}/components`;

const phoneUtil = PhoneNumberUtil.getInstance();

const App = () => {
    Config.setEnvironment(cfg.cleeng.environment);
    Config.setPublisher(cfg.cleeng.publisher_id);
    Config.setMyAccountUrl(url_account);
    Config.setCheckoutPayPalUrls({
        successUrl: url_components,
        cancelUrl: url_components,
        errorUrl: url_components,
    });
    Config.setMyAccountPayPalUrls({
        successUrl: url_account,
        cancelUrl: url_account,
        errorUrl: url_account,
    });
    Config.setTheme({
        fontColor: "#292525",
        backgroundColor: "#fff",
        cardColor: "#fff",
        successColor: "#435dc5",
        primaryColor: "#435dc5",
        loaderColor: "#cccccc",
        errorColor: "red",
        logoUrl: "link-to-the-logo",
    });
    //Config.setVisibleAdyenPaymentMethods(cfg.cleeng.payment_methods);
    Config.setHidePayPal();
    Config.setLanguage("en");
    Config.setResetUrl(
        `${cfg.sso.url}/#/sso/reset-pwd?client_id=${cfg.sso.clientId}`,
    );
    Config.setGoogleRecaptcha({
        showCaptchaOnRegister: true,
        showCaptchaOnPurchase: true,
        //, sitekey: SITEKEY_VALUE
    });
    Config.setTermsUrl('https://www.newsmax.com/termsconditions/?utm_source=nmplus&utm_medium=footer');

    const executeValidationScript = () => {
        const setReactInputValue = (input, value) => {
            const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
            nativeSetter.call(input, value);
            input.dispatchEvent(new Event('input', { bubbles: true }));
        };

        const toE164 = (value, defaultRegion = 'US') => {
            try {
                const parsed = phoneUtil.parseAndKeepRawInput(value, defaultRegion);
                if (phoneUtil.isValidNumber(parsed)) {
                    return phoneUtil.format(parsed, PhoneNumberFormat.E164);
                }
            } catch (e) {}
            return null;
        };
        
        var phoneObserver = new MutationObserver(function () {
            const input = document.querySelector('input#Mobile\\ phone');
            if (!input || input._phoneListenerAttached) return;
            input._phoneListenerAttached = true;

            input.addEventListener('blur', function () {
                const e164 = toE164(this.value);
                if (e164 && e164 !== this.value) {
                    setReactInputValue(this, e164);
                }
            });
        });
        phoneObserver.observe(document.body, { childList: true, subtree: true });

        /*
        const observer = new MutationObserver(function (observer) {
            const input = $(document).find("input#Mobile\\ phone");
            const description = $(document).find("#Mobile\\ phone-desc");
            const button = $(document).find("button.msd__button--confirm");

            removePlaceholders();

            input.on("blur", function () {
                var phoneValue = $(this).val();
                var phonePattern = /^[2-9]\d{9}$/;

                if (!phoneValue) {
                    description.hide();
                    button.removeAttr("disabled");
                } else if (!phonePattern.test(phoneValue)) {
                    description.text("Please enter a valid phone number.");
                    description.show();
                    button.attr("disabled", "disabled");
                } else {
                    description.hide();
                    button.removeAttr("disabled");
                }
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
        */
    };

    const removePlaceholders = () => {
        // Select inputs
        const recipientInput = document.querySelector(
            'input[name="recipientEmail"]',
        );
        const confirmInput = document.querySelector(
            'input[name="confirmRecipientEmail"]',
        );
        const messageArea = document.querySelector('textarea[name="message"]');

        // Remove placeholder if element exists
        if (recipientInput) recipientInput.removeAttribute("placeholder");
        if (confirmInput) confirmInput.removeAttribute("placeholder");
        if (messageArea) messageArea.removeAttribute("placeholder");
    };

    return (
        <Provider store={store}>
            <div className="App">
                <Router>
                    <main>
                        <Popups>
                            <Switch>
                                <Route exact path="/" component={() => <Home2 />} />
                                <Route exact path="/give-a-gift" component={() => <HomePageWithGift />} />
                                
                                {/*<Route exact path="/annual" component={() => <HomePage />} /> */}
                                {/*<Route exact path="/freemonth" component={() => <HomePage />} /> */}
                                {/*<Route exact path="/americaprays" component={() => <AmericaPrays />} />*/}
                                {/*<Route exact path="/subscribe" component={() => <WinBack />} />*/}
                                {/*<Route exact path="/fluent" component={() => <Fluent />} />*/}
                                <Route
                                    exact
                                    path="/experience"
                                    component={() => <Suspense fallback={<div>Loading...</div>}><Experience /></Suspense>}
                                />
                                <Route exact path="/experienceii" component={() => <Home2 />} />
                                <Route
                                    exact
                                    path="/subscribeexperience"
                                    component={() => <Suspense fallback={<div>Loading...</div>}><SubscribeExperience /></Suspense>}
                                />
                                {/*<Route exact path="/trump" component={() => <Trump />} />*/}
                                {/*<Route exact path="/americaprays" component={() => <AmericaPrays />} /> { */}

                                <Route exact path="/components" component={() => <Components />} />

                                <Route
                                    exact
                                    path="/redeem-gift"
                                    component={() => <RedeemMyGift />}
                                />
                                <Route path="/account" component={() => <AccountPage />} />
                                {/* } <Route exact path="/gift" component={() => <Gift />} /> { */}

                                <Route exact path="/access" component={() => <Suspense fallback={<div>Loading...</div>}><AccessPage /></Suspense>} />
                                <Route exact path="/unlock-access" component={() => <Suspense fallback={<div>Loading...</div>}><UnlockAccessPage /></Suspense>} />

                                <Route exact path="/checkout/:subtype?" component={() => <Suspense fallback={<div>Loading...</div>}><CheckoutPage /></Suspense>} />
                                <Route exact path="/renew/checkout/:subtype?" component={() => <Suspense fallback={<div>Loading...</div>}><RenewalCheckoutPage /></Suspense>} />

                                {/* /c/ for custom */}
                                <Route exact path="/c/checkout/:subtype?" component={() => <Suspense fallback={<div>Loading...</div>}><CustomCheckoutPage /></Suspense>} />
                                <Route exact path="/p/:promoCode/checkout" component={() => <PromoCodeCheckout />} />
                                <Route exact path="/p/:promoCode/shipping" component={() => <UpdateShippingAddress />} />

                                <Route exact path="/confirm" component={() => <Suspense fallback={<div>Loading...</div>}><OrderConfirmed /></Suspense>} />
                                <Route exact path="/start-watching" component={() => <Suspense fallback={<div>Loading...</div>}><StartWatchingPage /></Suspense>} />

                                <Route exact path="/cookiepolicy" component={() => <CookiePolicyComponent />} />

                                <Route component={() => <NotFound />} />
                            </Switch>
                        </Popups>
                        {executeValidationScript()}
                    </main>
                </Router>
            </div>
        </Provider>
    );
};

export default App;
